import { BASE_URL } from '../../config';
import {
    OPEN_AREA_MODAL,
    CLOSE_AREA_MODAL,
    AREA_CREATED,
    AREA_UPDATED,
    GET_AREA_LIST
} from './area.actionsTypes';
import axios from 'axios';
import Notifier from '../../components/message/Notifier';


export const areaCreated = (area) => {
    return {
        type: AREA_CREATED,
        area
    };
}

export const areaUpdated = (area, id) => {
    return {
        type: AREA_UPDATED,
        area,
        id
    };
};

export const openAreaModal = (selectedArea = null) => {
    return {
        type: OPEN_AREA_MODAL,
        selectedArea
    };
};

export const closeAreaModal = () => {
    return {
        type: CLOSE_AREA_MODAL
    };
};

export const getAreaList = (force = false) => {
    return (dispatch, getState) => {
        const state = getState ? getState() : {};
        const existingList = state?.areaDetails?.areaList;

        if (Array.isArray(existingList) && existingList.length && !force) {
            return;
        }

        return axios
            .get(`${BASE_URL}configs/areas`)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: GET_AREA_LIST,
                        areaList: response.data
                    });
                }
            })
            .catch((e) => {
                console.log(`${BASE_URL}configs/areas`, e);
            });
    };
};

export const createAreaByAPI = (data, cb) => {
    return (dispatch) => {
        axios.post(`${BASE_URL}configs/area`, data)
            .then((response) => {
                if (response.data) {
                    dispatch(areaCreated(response.data));
                    Notifier.success('_area_successfully_created_', '_area_created_');
                    cb(response.data);
                }
            });
    };
};

export const updateAreaByAPI = (id, data, cb) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}configs/updateArea/${id}`, data)
            .then((response) => {
                if (response.data) {
                    dispatch(areaUpdated(response.data, id));
                    Notifier.success('_area_successfully_updated_', '_area_updated_');
                    cb(response.data);
                }
            });
    };
};
